export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";

export const REMOVE_WISHLIST_ITEM = "REMOVE_WISHLIST_ITEM";
